import moment from "moment";
import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Rows = ({
  colCount,
  colData,
  colStyle,
  daysInMonth,
  currentDate = {},
  isLoading = false,
}) => {
  const today = moment().format("l");
  console.log("Today's date:", moment().format("l"));

  return (
    <div className={`grid ${colCount}`}>
      {colData.map((col, idx) => (
        <div
          className={`flex flex-col items-center justify-center ${colStyle} ${
            isLoading
              ? "bg-white"
              : moment([
                  currentDate.year,
                  currentDate.month,
                  col?.value,
                ]).format("l") === today
              ? "bg-header text-white"
              : col?.bgColor || ""
          }${
            col?.isWeekend
              ? "pointer-events-none opacity-50 cursor-not-allowed"
              : ""
          }`}
          key={`${col}${idx}`}
          onClick={col.onClick}
        >
          {col?.value || col}
          {daysInMonth && col?.value ? (
            col?.status && !col?.isWeekend ? (
              <span
                className={`text-xs text-center text-white rounded-full font-semibold ${
                  col.status === "Present" ? " bg-green-600" : " bg-red-600"
                } p-1 size-6`}
              >
                {col.status === "Present" ? "P" : "A" || "N"}
              </span>
            ) : (
              <span
                className={`text-xs text-center  rounded-full font-semibold ${
                  isLoading
                    ? "bg-white text-white"
                    : moment([
                        currentDate.year,
                        currentDate.month,
                        col?.value,
                      ]).format("l") === today
                    ? "bg-header text-header"
                    : new Date() >
                        new Date(
                          `${currentDate.year},${
                            Number(currentDate.month) + 1
                          },${col?.value}`
                        ) && !col?.isWeekend
                    ? "bg-gray-500 text-white"
                    : "bg-white text-white"
                } p-1 size-6`}
              >
                N
              </span>
            )
          ) : null}
        </div>
      ))}
    </div>
  );
};

const MonthRow = ({ colCount, colData, colStyle, onClick, currentMonth }) => {
  return (
    <div className={`grid grid-cols-11 gap-4 border-b-2 mt-4 mb-3`}>
      <div
        className={`flex justify-center items-center pb-3`}
        onClick={() => onClick(currentMonth - 1 < 0 ? 11 : currentMonth - 1)}
      >
        <FaChevronLeft />
      </div>
      {colData.map((col, idx) => (
        <div
          className={`flex justify-center col-span-3 items-center pb-3 ${
            currentMonth === col.monIndex
              ? "border-b-2 border-childLeave text-black font-medium"
              : ""
          }`}
          key={`${col}${idx}`}
          onClick={() => onClick(col.monIndex)}
        >
          {col?.value || col}
        </div>
      ))}
      <div
        className={`flex justify-center items-center pb-3`}
        onClick={() => onClick((currentMonth + 1) % 12)}
      >
        <FaChevronRight />
      </div>
    </div>
  );
};

export { Rows, MonthRow };
